"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadeBackground = void 0;
const getShadeBackground = (shade, theme) => {
  const {
    hexColors,
    imageUrl
  } = shade;
  if (hexColors?.length === 1 && hexColors[0]) {
    return hexColors[0];
  }
  if (hexColors && hexColors.length > 1) {
    return `linear-gradient(to right, ${hexColors[0]}, ${hexColors[0]} 50%, ${hexColors[1]} 50%)`;
  }
  if (imageUrl) {
    return `url(${imageUrl})`;
  }
  return theme.palette.common.white;
};
exports.getShadeBackground = getShadeBackground;
//# sourceMappingURL=getShadeBackground.js.map